// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PrescriberLicenseModel {
    static getAttributeTypeMap() {
        return PrescriberLicenseModel.attributeTypeMap;
    }
}
PrescriberLicenseModel.discriminator = undefined;
PrescriberLicenseModel.additionalProperties = false;
PrescriberLicenseModel.attributeTypeMap = [
    {
        "name": "prescriberLicenseId",
        "baseName": "prescriberLicenseId",
        "type": "number"
    },
    {
        "name": "licenseType",
        "baseName": "licenseType",
        "type": "PrescriberLicenseType"
    },
    {
        "name": "licenseNumber",
        "baseName": "licenseNumber",
        "type": "string"
    },
    {
        "name": "licenseStateCd",
        "baseName": "licenseStateCd",
        "type": "string"
    },
    {
        "name": "licenseExpirationDt",
        "baseName": "licenseExpirationDt",
        "type": "Date"
    },
];
//# sourceMappingURL=prescriberLicenseModel.js.map